// extracted by mini-css-extract-plugin
module.exports = {"root":"FieldPillInputGroup_root__1TEr9","list":"FieldPillInputGroup_list__3SiZa","item":"FieldPillInputGroup_item__1HPf5"};